import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=4ef745c3&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=4ef745c3&prod&scoped=true&lang=scss"
import style1 from "./Pagination.vue?vue&type=style&index=1&id=4ef745c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef745c3",
  null
  
)

export default component.exports